import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Guards the Integrations screens. Third-party credential management is ADMIN-only — SUB_ADMIN is
 * deliberately excluded. This is a routing convenience, NOT the security boundary: the backend's
 * ProviderConfig.assertAdmin() re-derives the caller from the AM_DB token and enforces the same
 * rule on every request, so a hand-typed URL gains nothing.
 */
export const credentialAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isAuthenticated()) return router.createUrlTree(['/login']);
  return auth.isFullAdmin() ? true : router.createUrlTree(['/']);
};
